module.exports = __webpack_public_path__ + "static/media/asset6.bff6f3d9.png";